import React, { useEffect, useState } from "react";
import styled from "styled-components";
import ActionHeader from "../../components/ActionHeader";
import { Button } from "baseui/button";
import { useNavigate } from "react-router-dom";
import request from "../../utils/http";
import { StyledTable, StyledHeadCell, StyledBodyCell } from "baseui/table-grid";
import { Pagination } from "baseui/pagination";
import { Input } from "baseui/input";
import toaster from "../../utils/toaster";

const Container = styled.div``;

const StyledTableRow = styled.div`
	display: contents;
	cursor: pointer;
`;

const itemsPerPage = 50;

interface LoadJobCodesParams {
	pageNumber: number;
	pageSize: number;
	searchText: string;
}

const JobCodeList = () => {
	const navigate = useNavigate();
	const [jobCodes, setJobCodes] = useState([] as any);
	const [currentPage, setCurrentPage] = useState(1);
	const [searchText, setSearchText] = useState("");
	const [loadSuccess, setLoadSuccess] = useState(false);

	const loadJobCodes = async ({
		pageNumber,
		pageSize,
		searchText,
	}: LoadJobCodesParams) => {
		console.log("Loading job codes...", pageNumber, pageSize, searchText); // Debugging
		try {
			const params = new URLSearchParams({
				pageNumber: pageNumber.toString(),
				pageSize: pageSize.toString(),
				searchText,
			});

			const url = `/api/admin/jobcode?${params.toString()}`;
			const result = await request("GET", url, null);
			setLoadSuccess(result.success);

			if (result.success && result.data) {
				setJobCodes(result.data.jobCodes);
			}
			else
			{
				toaster.error(result.message);
			}

		} catch (error) {
			console.error("Error loading job codes:", error); // Debugging
			// Handle error loading job codes.
		}
	};

	useEffect(() => {
		loadJobCodes({
			pageNumber: currentPage,
			pageSize: itemsPerPage,
			searchText: searchText,
		});
	}, [currentPage, searchText]);

	const startIndex = (currentPage - 1) * itemsPerPage;
	const endIndex = startIndex + itemsPerPage;

	return (
		<Container>
			<ActionHeader>
				<h1>Job Codes</h1>

			{loadSuccess && 
				<Button
					onClick={() => {
						navigate({
							pathname: `/job-code/create`,
						});
					}}
				>
					Create Job Code
				</Button>				
			}

			</ActionHeader>
			<hr />
			<Input
				value={searchText}
				onChange={(e) => setSearchText(e.currentTarget.value)}
				placeholder="Search..."
			/>
			<br />
			<StyledTable role="grid" $gridTemplateColumns={"1fr 1fr 1fr"}>
				<StyledTableRow role="row">
					<StyledHeadCell>Code</StyledHeadCell>
					<StyledHeadCell>Name</StyledHeadCell>
					<StyledHeadCell>Active</StyledHeadCell>
				</StyledTableRow>

				{jobCodes &&
					jobCodes
						.slice(startIndex, endIndex)
						.map((jobCode: any, i: number) => {
							const striped = i % 2 === 0;

							return (
								<StyledTableRow
									id={jobCode.id}
									role="row"
									onClick={() => {
										// Navigate to the edit page for the selected job code.
										navigate(`/job-code/edit/${jobCode.id}`);
									}}
								>
									<StyledBodyCell $striped={striped}>
										{jobCode.jobCode}
									</StyledBodyCell>
									<StyledBodyCell $striped={striped}>
										{jobCode.jobCodeName}
									</StyledBodyCell>
									<StyledBodyCell $striped={striped}>
										{jobCode.active ? "Yes" : "No"}
									</StyledBodyCell>
								</StyledTableRow>
							);
						})}
			</StyledTable>
			<Pagination
				numPages={Math.ceil(jobCodes.length / itemsPerPage)}
				currentPage={currentPage}
				onPageChange={({ nextPage }) => {
					setCurrentPage(
						Math.min(
							Math.max(nextPage, 1),
							Math.ceil(jobCodes.length / itemsPerPage)
						)
					);
				}}
			/>
		</Container>
	);
};

export default JobCodeList;
